// extracted by mini-css-extract-plugin
export default {"wrapper":"eKGdM","variant-yellow":"zI36K","variant-red":"IJoj6","variant-green":"KSin5"};